import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import Container from '@mui/material/Container';
import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import TextField from '@mui/material/TextField';
import Modal from '@mui/material/Modal';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Footer from '../Materials/Footer';
import Checkbox from '@mui/material/Checkbox';
import BurgerBar from '../Materials/BurgerBar';
import Link from '@mui/material/Link';
import TablePagination from '@mui/material/TablePagination';
import Paper from '@mui/material/Paper';
import TableContainer from '@mui/material/TableContainer';
import CloudUploadIcon from '@mui/icons-material/CloudUpload'; 
import Menu from '@mui/material/Menu';

export default function NewPage() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openDrawer, setOpenDrawer] = React.useState(false);
  const navigate = useNavigate();

  const [advices, setAdvices] = React.useState([]);
  const [openAdviceModal, setOpenAdviceModal] = React.useState(false);
  const [openAddAdviceModal, setOpenAddAdviceModal] = React.useState(false);
  const [title, setTitle] = React.useState('');
  const [adviceTitle, setAdviceTitle] = React.useState('');
  const [program, setProgram] = React.useState('');
  const [openDate, setOpenDate] = React.useState('');
  const [submissionPeriod, setSubmissionPeriod] = React.useState('');
  const [resume, setResume] = React.useState('');
  const [maximumAllocation, setMaximumAllocation] = React.useState('');
  const [financialMaximumTax, setFinancialMaximumTax] = React.useState('');
  const [link, setLink] = React.useState('');
  const [maximumDuration, setMaximumDuration] = React.useState('');
  const [regionId, setRegionId] = React.useState('');
  const [adviceTypeId, setAdviceTypeId] = React.useState('');
  const [selectedAdviceIndex, setSelectedAdviceIndex] = React.useState(null);
  const [loading, setLoading] = React.useState(false);

  // Estados para mensagens e confirmação
  const [notification, setNotification] = React.useState({
    open: false,
    message: '',
    severity: 'success'
  });
  const [openDeleteConfirm, setOpenDeleteConfirm] = React.useState(false);
  const [adviceToDelete, setAdviceToDelete] = React.useState(null);

  // Estados para carregar tipos de advice e regiões
  const [adviceTypes, setAdviceTypes] = React.useState([]);
  const [regions, setRegions] = React.useState([]);
  const [entityTypes, setEntityTypes] = React.useState([]);
  const [entityTypeIds, setEntityTypeIds] = React.useState([]);

  // Estados para paginação
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(8);

  // Estado para menu dropdown do botão de adicionar
  const [addMenuAnchorEl, setAddMenuAnchorEl] = React.useState(null);
  const addMenuOpen = Boolean(addMenuAnchorEl);

  // Carregar advices, tipos de advice e regiões ao montar o componente
  React.useEffect(() => {
    fetchAdvices();
    fetchAdviceTypes();
    fetchRegions();
    fetchEntityTypes();
  }, []);

  const formatDateForInput = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const fetchEntityTypes = async () => {
    try {
      const response = await fetch('https://api.hub4food.colab4food.com/api/entity-types');
      const data = await response.json();
      setEntityTypes(data);
    } catch (error) {
      console.error('Erro ao buscar tipos de entidade:', error);
    }
  };

  // Função para buscar advices
  const fetchAdvices = async () => {
    try {
      const response = await fetch('https://api.hub4food.colab4food.com/api/advices');
      const data = await response.json();
      setAdvices(data);
    } catch (error) {
      console.error('Erro ao buscar advices:', error);
    }
  };

  // Função para buscar tipos de advice
  const fetchAdviceTypes = async () => {
    try {
      const response = await fetch('https://api.hub4food.colab4food.com/api/adviceTypes');
      const data = await response.json();
      setAdviceTypes(data);
    } catch (error) {
      console.error('Erro ao buscar tipos de advice:', error);
    }
  };

  // Função para buscar regiões
  const fetchRegions = async () => {
    try {
      const response = await fetch('https://api.hub4food.colab4food.com/api/regions');
      const data = await response.json();
      setRegions(data);
    } catch (error) {
      console.error('Erro ao buscar regiões:', error);
    }
  };

  const showNotification = (message, severity = 'success') => {
    setNotification({
      open: true,
      message,
      severity
    });
  };

  const handleCloseNotification = () => {
    setNotification((prev) => ({
      ...prev,
      open: false
    }));
  };

  const handleOpenDeleteConfirm = (advice) => {
    setAdviceToDelete(advice);
    setOpenDeleteConfirm(true);
  };

  const handleCloseDeleteConfirm = () => {
    setOpenDeleteConfirm(false);
    setAdviceToDelete(null);
  };

  const handleAddAdvice = async () => {
    setLoading(true);
    try {
      
      if (!title || !adviceTitle || !program || !openDate || !regionId || !adviceTypeId || !entityTypeIds) {
        showNotification('Please fill in all required fields.', 'warning');
        return;
      }
  
      // Converter campos numéricos
      const maximumAllocationNumber = parseFloat(maximumAllocation);
      const maximumDurationNumber = parseInt(maximumDuration);
  
      // Validar campos numéricos
      if (isNaN(maximumAllocationNumber)) {
        showNotification('Maximum Allocation must be a valid number.', 'warning');
        return;
      }

      if (isNaN(maximumDurationNumber)) {
        showNotification('Maximum Duration must be a valid number.', 'warning');
        return;
      }

      if (entityTypeIds.length === 0) {
        showNotification('Please select at least one entity type.', 'warning');
        return;
      }
  
      const response = await fetch('https://api.hub4food.colab4food.com/api/advices', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          title,
          advice_title: adviceTitle,
          program,
          open_date: openDate,
          submission_period: submissionPeriod,
          resume,
          maximum_allocation: maximumAllocationNumber,
          financial_maximum_tax: financialMaximumTax,
          link,
          maximum_duration: maximumDurationNumber,
          region_id: regionId,
          advice_type: adviceTypeId,
          entity_type_id: entityTypeIds,
        }),
      });

      if (!response.ok) {
        throw new Error('Failed to create call');
      }

      const newAdvice = await response.json();
      setAdvices([...advices, newAdvice]);
      setOpenAddAdviceModal(false);
      resetAdviceForm();

      showNotification('Call created successfully!', 'success');
    } catch (error) {
      console.error('Erro ao adicionar advice:', error);

      showNotification(
        'Unable to create the call. Please check the information and try again.',
        'error'
      );
    } finally {
      setLoading(false);
    }
  };

  const handleEditAdvice = async () => {
    setLoading(true);
    try {
      const response = await fetch(`https://api.hub4food.colab4food.com/api/advices/${advices[selectedAdviceIndex].id}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          title,
          advice_title: adviceTitle,
          program,
          open_date: openDate,
          submission_period: submissionPeriod,
          resume,
          maximum_allocation: maximumAllocation,
          financial_maximum_tax: financialMaximumTax,
          link,
          maximum_duration: maximumDuration,
          region_id: regionId,
          advice_type: adviceTypeId,
          entity_type_id: entityTypeIds, 
        }),
      });

      if (!response.ok) {
        throw new Error('Failed to update call');
      }

      const updatedAdvice = await response.json();
      const updatedAdvices = [...advices];
      updatedAdvices[selectedAdviceIndex] = updatedAdvice;
      setAdvices(updatedAdvices);
      setOpenAdviceModal(false);
      resetAdviceForm();

      showNotification('Call updated successfully!', 'success');
    } catch (error) {
      console.error('Erro ao editar advice:', error);

      showNotification(
        'Unable to update the call. Please check the information and try again.',
        'error'
      );
    } finally {
      setLoading(false);
    }
  };

  // Função para apagar um advice
  const handleDeleteAdvice = async () => {
    if (!adviceToDelete) return;

    try {
      const response = await fetch(
        `https://api.hub4food.colab4food.com/api/advices/${adviceToDelete.id}`,
        { method: 'DELETE' }
      );

      if (!response.ok) {
        throw new Error('Failed to delete call');
      }

      setAdvices(
        advices.filter((advice) => advice.id !== adviceToDelete.id)
      );

      handleCloseDeleteConfirm();
      showNotification('Call deleted successfully!', 'success');
    } catch (error) {
      console.error('Erro ao apagar a call:', error);

      showNotification(
        'Unable to delete the call. Please try again.',
        'error'
      );
    }
  };

  const resetAdviceForm = () => {
    setTitle('');
    setAdviceTitle('');
    setProgram('');
    setOpenDate('');
    setSubmissionPeriod('');
    setResume('');
    setMaximumAllocation('');
    setFinancialMaximumTax('');
    setLink('');
    setMaximumDuration('');
    setRegionId('');
    setAdviceTypeId('');
    setSelectedAdviceIndex(null);
  };

  // Ao abrir o modal de criação
  const handleOpenAddAdviceModal = () => {
    resetAdviceForm(); // Resetar o formulário
    setOpenAddAdviceModal(true);
  };

  // Ao fechar o modal de edição
  const handleCloseEditModal = () => {
    resetAdviceForm(); // Resetar o formulário
    setOpenAdviceModal(false);
  };

  // Função para abrir o modal de edição
  const handleEditAdviceClick = (index) => {
    const advice = advices[index];
    const initialEntityTypeIds = advice.entity_type_id 
    ? Array.isArray(advice.entity_type_id) 
      ? advice.entity_type_id 
      : [advice.entity_type_id]
    : [];
    setTitle(advice.title);
    setAdviceTitle(advice.advice_title);
    setProgram(advice.program);
    setOpenDate(formatDateForInput(advice.open_date));
    setSubmissionPeriod(advice.submission_period);
    setResume(advice.resume);
    setMaximumAllocation(advice.maximum_allocation);
    setFinancialMaximumTax(advice.financial_maximum_tax);
    setLink(advice.link);
    setMaximumDuration(advice.maximum_duration);
    setRegionId(advice.region_id);
    setAdviceTypeId(advice.advice_type);
    setEntityTypeIds(initialEntityTypeIds);
    setSelectedAdviceIndex(index);
    setOpenAdviceModal(true);
  };

  // Funções para o Navbar e Drawer
  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDrawerToggle = () => {
    setOpenDrawer(!openDrawer);
  };

  const handleNavigation = (path) => {
    navigate(path);
    setOpenDrawer(false);
  };

  const handleExit = () => {
    localStorage.removeItem('user');
    navigate('/');
  };

  // Funções para paginação
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Resetar para a primeira página ao mudar o número de linhas por página
  };

  // Funções para o menu dropdown de adicionar
  const handleAddMenuClick = (event) => {
    setAddMenuAnchorEl(event.currentTarget);
  };

  const handleAddMenuClose = () => {
    setAddMenuAnchorEl(null);
  };

  const handleImportCSV = () => {
    handleAddMenuClose();
    navigate('/import-csv'); // Navegar para a página de importação
  };

  // Calcular os advices a mostrar na página atual
  const displayedAdvices = advices.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  // Renderização
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      {/* Navbar */}
      <BurgerBar />
      
      {/* Main Content */}
      <Box component="main" sx={{ flexGrow: 1, py: 4 }}>
        <Container maxWidth="lg">
          <Card>
            <CardContent>
              <Box display="flex" justifyContent="space-between" alignItems="center">
                <Typography variant="h6">Calls</Typography>
                <Box>
                  <IconButton 
                    color="primary" 
                    onClick={handleAddMenuClick}
                    aria-controls={addMenuOpen ? 'add-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={addMenuOpen ? 'true' : undefined}
                  >
                    <AddIcon />
                  </IconButton>
                  <Menu
                    id="add-menu"
                    anchorEl={addMenuAnchorEl}
                    open={addMenuOpen}
                    onClose={handleAddMenuClose}
                    MenuListProps={{
                      'aria-labelledby': 'basic-button',
                    }}
                  >
                    <MenuItem onClick={() => { handleAddMenuClose(); handleOpenAddAdviceModal(); }}>
                      <AddIcon sx={{ mr: 1 }} /> Add Call
                    </MenuItem>
                    <MenuItem onClick={handleImportCSV}>
                      <CloudUploadIcon sx={{ mr: 1 }} /> Import CSV
                    </MenuItem>
                  </Menu>
                </Box>
              </Box>
              <Box sx={{ mt: 2, overflow: 'hidden' }}>
                <TableContainer component={Paper} sx={{ maxHeight: 440, overflow: 'auto' }}>
                  <Table stickyHeader sx={{ minWidth: 650 }}>
                    <TableHead>
                      <TableRow>
                        <TableCell align="center" sx={{ minWidth: 150 }}>Title</TableCell>
                        <TableCell align="center" sx={{ minWidth: 150 }}>Call Type</TableCell>
                        <TableCell align="center" sx={{ minWidth: 200 }}>Link</TableCell>
                        <TableCell align="center" sx={{ minWidth: 150 }}>Region</TableCell>
                        <TableCell align="center" sx={{ minWidth: 150 }}>Actions</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {displayedAdvices.map((advice, index) => (
                        <TableRow key={advice.id} hover>
                          <TableCell align="center">{advice.title}</TableCell>
                          <TableCell align="center">
                            {adviceTypes.find((type) => type.id === advice.advice_type)?.type}
                          </TableCell>
                          <TableCell align="center">
                            <Link 
                              href={advice.link} 
                              target="_blank" 
                              rel="noopener noreferrer"
                              onClick={(e) => e.stopPropagation()} 
                              sx={{ 
                                display: 'inline-block',
                                maxWidth: '200px',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap'
                              }}
                            >
                              {advice.link}
                            </Link>
                          </TableCell>
                          <TableCell align="center">
                            {regions.find((region) => region.id === advice.region_id)?.name}
                          </TableCell>
                          <TableCell align="center">
                            <IconButton color="primary" onClick={() => handleEditAdviceClick(page * rowsPerPage + index)}>
                              <EditIcon />
                            </IconButton>
                            <IconButton color="error" onClick={() => handleOpenDeleteConfirm(advice)}>
                              <DeleteIcon />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
                
                {/* Paginação */}
                <TablePagination
                  rowsPerPageOptions={[8, 16, 24, 32]}
                  component="div"
                  count={advices.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  labelRowsPerPage="Lines per page:"
                  labelDisplayedRows={({ from, to, count }) => 
                    `${from}-${to} de ${count !== -1 ? count : `mais de ${to}`}`
                  }
                />
              </Box>
            </CardContent>
          </Card>

          {/* Modal de Edição */}
          <Modal open={openAdviceModal} onClose={handleCloseEditModal}>
            <Box sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              backgroundColor: 'white',
              padding: 4,
              boxShadow: 24,
              width: '600px',
              maxHeight: '80vh', // Altura máxima do modal
              overflow: 'auto', // Adiciona scroll
            }}>
              <Typography variant="h6">Edit Call</Typography>
              <TextField
                fullWidth
                label="Title"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                sx={{ mt: 2 }}
              />
              <TextField
                fullWidth
                label="Call Title"
                value={adviceTitle}
                onChange={(e) => setAdviceTitle(e.target.value)}
                sx={{ mt: 2 }}
              />
              <TextField
                fullWidth
                label="Program"
                value={program}
                onChange={(e) => setProgram(e.target.value)}
                sx={{ mt: 2 }}
              />
              <TextField
                fullWidth
                label="Open Date"
                type="date"
                value={openDate}
                onChange={(e) => setOpenDate(e.target.value)}
                sx={{ mt: 2 }}
                InputLabelProps={{
                  shrink: true, // Isso garante que o rótulo não sobreponha o valor
                }}
              />
              <TextField
                fullWidth
                label="Deadline"
                type="date"
                value={submissionPeriod}
                onChange={(e) => setSubmissionPeriod(e.target.value)}
                sx={{ mt: 2 }}
                InputLabelProps={{
                  shrink: true,
                }}
              />

              <TextField
                fullWidth
                label="Resume"
                value={resume}
                onChange={(e) => setResume(e.target.value)}
                sx={{ mt: 2 }}
              />
              <TextField
                fullWidth
                label="Maximum Allocation"
                value={maximumAllocation}
                onChange={(e) => setMaximumAllocation(e.target.value)}
                sx={{ mt: 2 }}
              />
              <TextField
                fullWidth
                label="Financial Maximum Tax"
                value={financialMaximumTax}
                onChange={(e) => setFinancialMaximumTax(e.target.value)}
                sx={{ mt: 2 }}
              />
              <TextField
                fullWidth
                label="Link"
                value={link}
                onChange={(e) => setLink(e.target.value)}
                sx={{ mt: 2 }}
              />
              <TextField
                fullWidth
                label="Maximum Duration"
                value={maximumDuration}
                onChange={(e) => setMaximumDuration(e.target.value)}
                sx={{ mt: 2 }}
              />
              <TextField
                select
                fullWidth
                label="Region"
                value={regionId}
                onChange={(e) => setRegionId(e.target.value)}
                sx={{ mt: 2 }}
              >
                {regions.map((region) => (
                  <MenuItem key={region.id} value={region.id}>
                    {region.name}
                  </MenuItem>
                ))}
              </TextField>
              <TextField
                select
                fullWidth
                label="Call Type"
                value={adviceTypeId}
                onChange={(e) => setAdviceTypeId(e.target.value)}
                sx={{ mt: 2 }}
              >
                {adviceTypes.map((type) => (
                  <MenuItem key={type.id} value={type.id}>
                    {type.type}
                  </MenuItem>
                ))}
              </TextField>

             <TextField
                select
                fullWidth
                label="Entity Type"
                SelectProps={{
                  multiple: true,
                  value: entityTypeIds,
                  onChange: (e) => setEntityTypeIds(e.target.value),
                  renderValue: (selected) => {
                    if (selected.length === 0) return "Select an entity type";
                    return selected.map(id => 
                      entityTypes.find(type => type.id === id)?.name
                    ).join(', ');
                  }
                }}
                sx={{ mt: 2 }}
              >
                {entityTypes.map((type) => (
                  <MenuItem key={type.id} value={type.id}>
                    <Checkbox checked={entityTypeIds.includes(type.id)} />
                    <ListItemText primary={type.name} />
                  </MenuItem>
                ))}
              </TextField>
              <Button variant="contained" color="primary" fullWidth onClick={handleEditAdvice} sx={{ mt: 3 }}>
                Save Changes
              </Button>
            </Box>
          </Modal>

          {/* Modal de Adição */}
          <Dialog open={openAddAdviceModal} onClose={() => setOpenAddAdviceModal(false)}>
            <DialogTitle>Create Call</DialogTitle>
            <DialogContent>
              <TextField
                fullWidth
                label="Title *"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                sx={{ mt: 2 }}
              />
              <TextField
                fullWidth
                label="Call Title *"
                value={adviceTitle}
                onChange={(e) => setAdviceTitle(e.target.value)}
                sx={{ mt: 2 }}
              />
              <TextField
                fullWidth
                label="Program *"
                value={program}
                onChange={(e) => setProgram(e.target.value)}
                sx={{ mt: 2 }}
              />
              <TextField
                fullWidth
                label="Open Date *"
                type="date"
                value={openDate}
                onChange={(e) => setOpenDate(e.target.value)}
                sx={{ mt: 2 }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
              <TextField
                fullWidth
                label="Deadline"
                type="date"
                value={submissionPeriod}
                onChange={(e) => setSubmissionPeriod(e.target.value)}
                sx={{ mt: 2 }}
                InputLabelProps={{
                  shrink: true,
                }}
              />

              <TextField
                fullWidth
                label="Resume"
                value={resume}
                onChange={(e) => setResume(e.target.value)}
                sx={{ mt: 2 }}
              />
              <TextField
                fullWidth
                label="Maximum Allocation *"
                type="number"
                value={maximumAllocation}
                onChange={(e) => setMaximumAllocation(e.target.value)}
                sx={{ mt: 2 }}
              />
              <TextField
                fullWidth
                label="Financial Maximum Tax *"
                value={financialMaximumTax}
                onChange={(e) => setFinancialMaximumTax(e.target.value)}
                sx={{ mt: 2 }}
              />
              <TextField
                fullWidth
                label="Link"
                value={link}
                onChange={(e) => setLink(e.target.value)}
                sx={{ mt: 2 }}
              />
              <TextField
                fullWidth
                label="Maximum Duration *"
                type="number"
                value={maximumDuration}
                onChange={(e) => setMaximumDuration(e.target.value)}
                sx={{ mt: 2 }}
              />
              <TextField
                select
                fullWidth
                label="Region *"
                value={regionId}
                onChange={(e) => setRegionId(e.target.value)}
                sx={{ mt: 2 }}
              >
                {regions.map((region) => (
                  <MenuItem key={region.id} value={region.id}>
                    {region.name}
                  </MenuItem>
                ))}
              </TextField>
              <TextField
                select
                fullWidth
                label="Call Type *"
                value={adviceTypeId}
                onChange={(e) => setAdviceTypeId(e.target.value)}
                sx={{ mt: 2 }}
              >
                {adviceTypes.map((type) => (
                  <MenuItem key={type.id} value={type.id}>
                    {type.type}
                  </MenuItem>
                ))}
              </TextField>

              <TextField
                select
                fullWidth
                label="Entity Type *"
                SelectProps={{
                  multiple: true,
                  value: entityTypeIds,
                  onChange: (e) => setEntityTypeIds(e.target.value),
                  renderValue: (selected) => selected.map(id => 
                    entityTypes.find(type => type.id === id)?.name
                  ).join(', ')
                }}
                sx={{ mt: 2 }}
              >
                {entityTypes.map((type) => (
                  <MenuItem key={type.id} value={type.id}>
                    <Checkbox checked={entityTypeIds.includes(type.id)} />
                    <ListItemText primary={type.name} />
                  </MenuItem>
                ))}
              </TextField>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setOpenAddAdviceModal(false)} color="error">
                Cancel
              </Button>
              <Button onClick={handleAddAdvice} color="primary" disabled={loading}>
                {loading ? 'Creating...' : 'Create'}
              </Button>
            </DialogActions>
          </Dialog>

          {/* Confirmação de eliminação */}
          <Dialog
            open={openDeleteConfirm}
            onClose={handleCloseDeleteConfirm}
          >
            <DialogTitle>Delete Call</DialogTitle>

            <DialogContent>
              <Typography>
                Are you sure you want to delete the call
                <strong> "{adviceToDelete?.title}"</strong>?
              </Typography>

              <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                This action cannot be undone.
              </Typography>
            </DialogContent>

            <DialogActions>
              <Button onClick={handleCloseDeleteConfirm} color="inherit">
                Cancel
              </Button>

              <Button
                onClick={handleDeleteAdvice}
                color="error"
                variant="contained"
              >
                Delete
              </Button>
            </DialogActions>
          </Dialog>

        </Container>
      </Box>

      {/* Snackbar para feedback */}
      <Snackbar
        open={notification.open}
        autoHideDuration={4000}
        onClose={handleCloseNotification}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
      >
        <Alert
          onClose={handleCloseNotification}
          severity={notification.severity}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {notification.message}
        </Alert>
      </Snackbar>

      {/* Footer */}
      <Box>
        <Footer />
      </Box>
    </Box>
  );
}